'use strict';

import controller from './financiamiento.controller';
import template from './financiamiento.html';

const DatosFinanciamiento = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default DatosFinanciamiento;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/financiamiento/financiamiento.component.js